/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiEntityType } from './InternalApiEntityType';
import {
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeFromJSONTyped,
    InternalApiEntityTypeToJSON,
    InternalApiEntityTypeToJSONTyped,
} from './InternalApiEntityType';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';
import type { InternalApiScreeningClearanceRuleContent } from './InternalApiScreeningClearanceRuleContent';
import {
    InternalApiScreeningClearanceRuleContentFromJSON,
    InternalApiScreeningClearanceRuleContentFromJSONTyped,
    InternalApiScreeningClearanceRuleContentToJSON,
    InternalApiScreeningClearanceRuleContentToJSONTyped,
} from './InternalApiScreeningClearanceRuleContent';

/**
 * 
 * @export
 * @interface InternalApiScreeningClearanceRuleWithAllContents
 */
export interface InternalApiScreeningClearanceRuleWithAllContents {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningClearanceRuleWithAllContents
     */
    handle?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningClearanceRuleWithAllContents
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningClearanceRuleWithAllContents
     */
    details: string;
    /**
     * 
     * @type {InternalApiEntityType}
     * @memberof InternalApiScreeningClearanceRuleWithAllContents
     */
    screeningType: InternalApiEntityType;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScreeningClearanceRuleWithAllContents
     */
    enabled: boolean;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiScreeningClearanceRuleWithAllContents
     */
    lastUpdatedBy?: InternalApiUserBasicDetails;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScreeningClearanceRuleWithAllContents
     */
    lastUpdatedTime?: Date;
    /**
     * 
     * @type {Array<InternalApiScreeningClearanceRuleContent>}
     * @memberof InternalApiScreeningClearanceRuleWithAllContents
     */
    contents?: Array<InternalApiScreeningClearanceRuleContent>;
}



/**
 * Check if a given object implements the InternalApiScreeningClearanceRuleWithAllContents interface.
 */
export function instanceOfInternalApiScreeningClearanceRuleWithAllContents(value: object): value is InternalApiScreeningClearanceRuleWithAllContents {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('screeningType' in value) || value['screeningType'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function InternalApiScreeningClearanceRuleWithAllContentsFromJSON(json: any): InternalApiScreeningClearanceRuleWithAllContents {
    return InternalApiScreeningClearanceRuleWithAllContentsFromJSONTyped(json, false);
}

export function InternalApiScreeningClearanceRuleWithAllContentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningClearanceRuleWithAllContents {
    if (json == null) {
        return json;
    }
    return {
        
        'handle': json['handle'] == null ? undefined : json['handle'],
        'reason': json['reason'],
        'details': json['details'],
        'screeningType': InternalApiEntityTypeFromJSON(json['screeningType']),
        'enabled': json['enabled'],
        'lastUpdatedBy': json['lastUpdatedBy'] == null ? undefined : InternalApiUserBasicDetailsFromJSON(json['lastUpdatedBy']),
        'lastUpdatedTime': json['lastUpdatedTime'] == null ? undefined : (new Date(json['lastUpdatedTime'])),
        'contents': json['contents'] == null ? undefined : ((json['contents'] as Array<any>).map(InternalApiScreeningClearanceRuleContentFromJSON)),
    };
}

export function InternalApiScreeningClearanceRuleWithAllContentsToJSON(json: any): InternalApiScreeningClearanceRuleWithAllContents {
    return InternalApiScreeningClearanceRuleWithAllContentsToJSONTyped(json, false);
}

export function InternalApiScreeningClearanceRuleWithAllContentsToJSONTyped(value?: InternalApiScreeningClearanceRuleWithAllContents | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'handle': value['handle'],
        'reason': value['reason'],
        'details': value['details'],
        'screeningType': InternalApiEntityTypeToJSON(value['screeningType']),
        'enabled': value['enabled'],
        'lastUpdatedBy': InternalApiUserBasicDetailsToJSON(value['lastUpdatedBy']),
        'lastUpdatedTime': value['lastUpdatedTime'] == null ? value['lastUpdatedTime'] : value['lastUpdatedTime'].toISOString(),
        'contents': value['contents'] == null ? undefined : ((value['contents'] as Array<any>).map(InternalApiScreeningClearanceRuleContentToJSON)),
    };
}

